import {
  Dialog, DialogContent, DialogHeader, DialogTitle, DialogClose, DialogDescription, DialogFooter,
  Button,
} from '@/components/ui'
import { type WorkflowRun, type WorkflowRunDetail } from '@/types'
import { X, XCircle } from 'lucide-react'

interface Props {
  run: WorkflowRun | WorkflowRunDetail | null
  open: boolean
  onOpenChange: (open: boolean) => void
  onConfirm: (runId: string) => void
}

export function CancelRunDialog({ run, open, onOpenChange, onConfirm }: Props) {
  if (!run) return null

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-[640px] rounded-2xl p-8 gap-6 border-none shadow-elevated" hideCloseButton>
        <DialogHeader className="flex-row items-center justify-between space-y-0">
          <DialogTitle className="text-2xl font-bold leading-[1.3] tracking-[0.015em] text-foreground">Cancel Workflow Run</DialogTitle>
          <DialogClose className="rounded-sm opacity-70 transition-opacity hover:opacity-100 focus:outline-none">
            <X className="h-6 w-6" />
            <span className="sr-only">Close</span>
          </DialogClose>
        </DialogHeader>
        <DialogDescription className="text-sm font-normal leading-[1.6] tracking-[0.015em] text-foreground">
          Are you sure you want to stop the "<span className="font-bold">{run.definitionDisplayName}</span>" workflow run? All progress will be halted and the process will not continue unless restarted.
        </DialogDescription>
        <DialogFooter>
          <Button variant="destructive" onClick={() => { onConfirm(run.id); onOpenChange(false) }}>
            <XCircle className="h-3 w-3 mr-1" /> Cancel Workflow Run
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
